module.exports = {
      id: "crown-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "svg-sprite-c16dead317bf40daa0a857495c90b974.svg#crown",
      toString: function () {
        return this.url;
      }
    }